import type { QuestionnaireResponse } from "@medplum/fhirtypes";

import {
  INPUT_OUTPUT_DATE_LINK_ID,
  INPUT_OUTPUT_DATE_TIME_LINK_ID,
  INPUT_OUTPUT_INPUT_LINK_ID,
  INPUT_OUTPUT_NOTES_LINK_ID,
  INPUT_OUTPUT_OUTPUT_LINK_ID,
  INPUT_OUTPUT_ROOT_LINK_ID,
  INPUT_OUTPUT_SIGNATURE_INITIALS_LINK_ID,
  INPUT_OUTPUT_TIME_LINK_ID,
} from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/constants/input-output-link-ids";
import type { InputOutputFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/types/input-output-form";
import { getEmptyInputOutputFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/utils/input-output-form-defaults";
import {
  findQuestionnaireResponseItem,
  parseQuestionnaireResponseLocalValueDate,
  readQuestionnaireSignatureInitials,
  readQuestionnaireStringAnswer,
} from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/questionnaire-response-readers";

export function mapQuestionnaireResponseToInputOutputFormValues(
  questionnaireResponse: QuestionnaireResponse | undefined,
): InputOutputFlowsheetFormValues {
  const emptyValues = getEmptyInputOutputFlowsheetFormValues();
  const root = findQuestionnaireResponseItem(
    questionnaireResponse?.item,
    INPUT_OUTPUT_ROOT_LINK_ID,
  );
  if (!root?.item) {
    return emptyValues;
  }

  const dateTimeGroup = findQuestionnaireResponseItem(root.item, INPUT_OUTPUT_DATE_TIME_LINK_ID);
  const dateAnswer = findQuestionnaireResponseItem(dateTimeGroup?.item, INPUT_OUTPUT_DATE_LINK_ID)
    ?.answer?.[0]?.valueDate;
  const timeAnswer = findQuestionnaireResponseItem(dateTimeGroup?.item, INPUT_OUTPUT_TIME_LINK_ID)
    ?.answer?.[0]?.valueTime;

  return {
    ...emptyValues,
    inputOutputDate: parseQuestionnaireResponseLocalValueDate(dateAnswer),
    inputOutputTime: timeAnswer ?? null,
    inputOutputInput: readQuestionnaireStringAnswer(
      findQuestionnaireResponseItem(root.item, INPUT_OUTPUT_INPUT_LINK_ID),
    ),
    inputOutputOutput: readQuestionnaireStringAnswer(
      findQuestionnaireResponseItem(root.item, INPUT_OUTPUT_OUTPUT_LINK_ID),
    ),
    inputOutputNotes: readQuestionnaireStringAnswer(
      findQuestionnaireResponseItem(root.item, INPUT_OUTPUT_NOTES_LINK_ID),
    ),
    signatureInitials: readQuestionnaireSignatureInitials(
      findQuestionnaireResponseItem(root.item, INPUT_OUTPUT_SIGNATURE_INITIALS_LINK_ID),
    ),
  };
}

export function mapInputOutputFormValuesToQuestionnaireValues(
  formValues: InputOutputFlowsheetFormValues,
): Record<string, unknown> {
  return {
    [INPUT_OUTPUT_ROOT_LINK_ID]: {
      [INPUT_OUTPUT_DATE_TIME_LINK_ID]: {
        [INPUT_OUTPUT_DATE_LINK_ID]: formValues.inputOutputDate,
        [INPUT_OUTPUT_TIME_LINK_ID]: formValues.inputOutputTime,
      },
      [INPUT_OUTPUT_INPUT_LINK_ID]: formValues.inputOutputInput,
      [INPUT_OUTPUT_OUTPUT_LINK_ID]: formValues.inputOutputOutput,
      [INPUT_OUTPUT_NOTES_LINK_ID]: formValues.inputOutputNotes,
      [INPUT_OUTPUT_SIGNATURE_INITIALS_LINK_ID]: formValues.signatureInitials,
    },
  };
}
